import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout/AdminLayout';
import HomePage from '../pages/Home/Home';
import ExplorePage from '../pages/Explore';
import WalletPage from '../pages/Wallet';
import ActivityPage from '../pages/Activity';
import RedPacketPage from '../pages/RedPacket';
import RedPacketEntry from '../pages/RedPacket/Entry';
import AIAgentsPage from '../pages/AIAgents';
import AccountPage from '../pages/Account';
import VouchersPage from '../pages/Vouchers';
import HelpPage from '../pages/Help';
import EcosystemPage from '../pages/Ecosystem';
import Login from '../pages/Login/Login';
import Register from '../pages/Register/Register';
import ResetPasswordPage from '../pages/Reset-password';
import ProtectedRoute from './ProtectedRoute';
import PublicOnlyRoute from './PublicOnlyRoute';
import IntercomMessenger from '../support/IntercomMessenger';

function AppShell() {
    return (
        <>
            <IntercomMessenger />
            <Outlet />
        </>
    );
}

export const router = createBrowserRouter([
    {
        element: <AppShell />,
        children: [
    {
        element: <PublicOnlyRoute />,
        children: [
            { path: '/login', element: <Login /> },
            { path: '/register', element: <Register /> },
            { path: '/reset-password', element: <ResetPasswordPage /> },
        ],
    },
    {
        element: <ProtectedRoute />,
        children: [
            {
                path: '/',
                element: <AdminLayout />,
                children: [
                    { index: true, element: <Navigate to="/home" replace /> },
                    { path: 'home', element: <HomePage /> },
                    { path: 'explore', element: <ExplorePage /> },
                    { path: 'wallet', element: <WalletPage /> },
                    { path: 'activity', element: <ActivityPage /> },
                    { path: 'ai-agents', element: <AIAgentsPage /> },
                    { path: 'account', element: <AccountPage /> },
                    { path: 'vouchers', element: <VouchersPage /> },
                    { path: 'help', element: <HelpPage /> },
                    { path: 'ecosystem', element: <EcosystemPage /> },
                ],
            },
        ],
    },
    {
        path: '/red-packet',
        element: <RedPacketEntry />,
        children: [{ index: true, element: <RedPacketPage /> }],
    },
    { path: '*', element: <Navigate to="/home" replace /> },
        ],
    },
]);
